var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.tooltip,
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled,
            placement: "top"
          }
        },
        [
          _c("CompassIconButton", {
            ref: "colorPaletteTrigger",
            attrs: {
              icon: _vm.icon,
              disabled: _vm.disabled,
              active: _vm.active,
              size: "small"
            },
            on: {
              click: function($event) {
                return _vm.$emit("update:visibility", !_vm.isVisible)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          attrs: {
            isVisible: _vm.isVisible,
            customClass: "color-palette-popover",
            triggerRef: "colorPaletteTrigger"
          },
          on: {
            close: function($event) {
              return _vm.$emit("update:visibility", false)
            }
          }
        },
        [
          [
            _c("div", { staticClass: "color-palette__content" }, [
              _c(
                "div",
                { staticClass: "color-palette__colors" },
                _vm._l(_vm.colorsGrid, function(row, rowIndex) {
                  return _c(
                    "div",
                    { key: rowIndex, staticClass: "color-palette__colors-row" },
                    _vm._l(row, function(color, colIndex) {
                      return _c(
                        "div",
                        {
                          key: colIndex,
                          staticClass: "color-palette__colors-cell"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "color-palette__colors-label",
                              style: { backgroundColor: color },
                              attrs: {
                                for: "color_" + rowIndex + "_" + colIndex
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("update:value", color)
                                }
                              }
                            },
                            [
                              _vm.value === color
                                ? _c("CompassIcon", {
                                    staticClass: "color-palette__colors-icon",
                                    attrs: { icon: "check", size: "small" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "color-palette__form" },
                [
                  _c("CompassColorInput", {
                    staticClass: "color-palette__form-color-input",
                    attrs: {
                      value: _vm.value,
                      canSelectColor: false,
                      size: "small"
                    },
                    on: {
                      change: function(color) {
                        return _vm.$emit("update:value", color)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassIconButton", {
                    staticClass: "color-palette__form-reset-button",
                    attrs: { icon: "paint-off", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("reset:value")
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }